import baumeSursisImg from "../assets/baumedesursis.png";
import bouillonDejavuImg from "../assets/bouillondejavu.png";
import elixirClarteImg from "../assets/elixir_clarte.png";
import grogVeuveImg from "../assets/grogveuve.png";
import liqueurMetamorpheImg from "../assets/liqueurDuMetamorphe.png";
import mixtureBrucolaqueImg from "../assets/mixtureDuBrucolaque.png";
import mixtureOeilImg from "../assets/mixture_oeil.png";
import philtreMnesiqueImg from "../assets/philtre_mnesique.png";
import philtreDemiLuneImg from "../assets/philtreDemiLune.png";
import potionDecouverteImg from "../assets/potion_decouverte.png";
import remedeIgnoranceImg from "../assets/remede_ignorance.png";
import serumCadranImg from "../assets/serum_cadran.png";
import { humanizeGemLabel } from "./gems";

export const QUESTION_TIME_LIMIT_SECONDS = 25;
export const QUESTION_TIME_EXTENDED_LIMIT_SECONDS = 50;
export const SERUM_CADRAN_TIME_BONUS_SECONDS = 25;

export const MEMORY_AID_POTION_IDS = new Set([
  "remede-ignorance",
  "philtre-mnesique",
  "elixir-clarte",
]);

export const TIME_AID_POTION_ID = "serum-cadran";

/** Potion de quête : remplace un objectif de la quête du jour (une fois par quête). */
export const METAMORPH_POTION_ID = "liqueur-du-metamorphe";
export const DEMI_LUNE_POTION_ID = "philtre-demi-lune";

/** Code enregistré par réponse : M = aide mémoire, T = aide au temps (sérum). */
export function getGameAnswerPotionAid(potionId) {
  if (MEMORY_AID_POTION_IDS.has(potionId)) return "M";
  if (potionId === TIME_AID_POTION_ID) return "T";
  return null;
}

export function formatGameResponseDuration(responseMs) {
  if (responseMs == null || !Number.isFinite(responseMs) || responseMs < 0) {
    return "—";
  }
  const seconds = responseMs / 1000;
  if (seconds < 10) {
    return `${seconds.toLocaleString("fr-FR", {
      minimumFractionDigits: 1,
      maximumFractionDigits: 1,
    })} s`;
  }
  return `${Math.round(seconds)} s`;
}

export const GAME_POTIONS = [
  {
    id: "decouverte",
    name: "Potion de découverte",
    obtainArticle: "une",
    image: potionDecouverteImg,
    themeColor: "#2B6FD4",
    themeClass: "potion-card--decouverte",
    description: "Remplace un mot déjà découvert par un mot jamais encore joué.",
    gameTooltipDescription:
      "Remplace une question sur un mot déjà découvert par une question sur un mot jamais encore joué.",
    starsAnimationDelay: 0,
    cost: {
      specificGemId: "topaze",
      specificGemCount: 1,
      commonGemCount: 3,
    },
  },
  {
    id: "bouillon-deja-vu",
    name: "Bouillon de Déjà-Vu",
    obtainArticle: "un",
    image: bouillonDejavuImg,
    themeColor: "#E05297",
    starsColor: "#8A8F98",
    themeClass: "potion-card--bouillon",
    description: "Remplace un mot joué 3 fois ou plus par un mot joué exactement 1 fois.",
    gameTooltipDescription:
      "Remplace une question sur un mot joué 3 fois ou plus par une question sur un mot joué exactement 1 fois.",
    starsAnimationDelay: 240,
    cost: {
      specificGemId: "opale",
      specificGemCount: 1,
      commonGemCount: 3,
    },
  },
  {
    id: "mixture-3eme-oeil",
    name: "Mixture du 3ème œil",
    obtainArticle: "une",
    image: mixtureOeilImg,
    themeColor: "#C9922E",
    themeClass: "potion-card--oeil",
    description: "Remplace un mot joué 3 fois ou plus par un mot joué exactement 2 fois.",
    gameTooltipDescription:
      "Remplace une question sur un mot joué 3 fois ou plus par une question sur un mot joué exactement 2 fois.",
    starsAnimationDelay: 480,
    cost: {
      specificGemId: "saphir",
      specificGemCount: 1,
      commonGemCount: 5,
    },
  },
  {
    id: "grog-veuve-noire",
    name: "Grog de la veuve noire",
    obtainArticle: "un",
    image: grogVeuveImg,
    themeColor: "#0B1628",
    themeClass: "potion-card--grog",
    description: "Remplace un mot maîtrisé par un mot déjà gradé inférieur à B+.",
    gameTooltipDescription:
      "Remplace une question sur un mot maîtrisé par une question sur un mot déjà gradé dont la gradation est inférieure à B+.",
    starsAnimationDelay: 720,
    cost: {
      specificGemId: "jais",
      specificGemCount: 1,
      commonGemCount: 2,
    },
  },
  {
    id: "serum-cadran",
    name: "Sérum du Cadran",
    obtainArticle: "un",
    image: serumCadranImg,
    themeColor: "#7B4DB8",
    starsColors: ["#7B4DB8", "#F5C518"],
    themeClass: "potion-card--serum",
    description: "Double le temps imparti pour répondre à une question (25 à 50 secondes).",
    starsAnimationDelay: 960,
    cost: {
      specificGemId: "améthyste",
      specificGemCount: 1,
      commonGemCount: 2,
    },
  },
  {
    id: "remede-ignorance",
    name: "Remède contre l'oubli",
    obtainArticle: "un",
    image: remedeIgnoranceImg,
    themeColor: "#2E9B52",
    themeClass: "potion-card--remede",
    description: "Donne la première lettre du mot à deviner.",
    starsAnimationDelay: 1440,
    cost: {
      specificGemId: "aventurine",
      specificGemCount: 1,
      commonGemCount: 3,
    },
  },
  {
    id: "philtre-mnesique",
    name: "Philtre mnésique",
    obtainArticle: "un",
    image: philtreMnesiqueImg,
    themeColor: "#C45A12",
    themeClass: "potion-card--philtre",
    description: "Donne la première et la dernière lettre du mot à deviner.",
    starsAnimationDelay: 0,
    cost: {
      specificGemId: "citrine",
      specificGemCount: 2,
      commonGemCount: 5,
    },
  },
  {
    id: "elixir-clarte",
    name: "Élixir de clarté",
    obtainArticle: "un",
    image: elixirClarteImg,
    themeColor: "#B83232",
    themeClass: "potion-card--elixir",
    description: "Révèle le nombre de lettres, les espaces, et deux lettres tirées au hasard.",
    gameTooltipDescription:
      "Indique la longueur du mot, les espaces, et deux lettres au hasard.",
    starsAnimationDelay: 480,
    cost: {
      specificGemId: "rubis",
      specificGemCount: 1,
      commonGemCount: 5,
    },
  },
  {
    id: "mixture-du-brucolaque",
    name: "Mixture du brucolaque",
    obtainArticle: "une",
    image: mixtureBrucolaqueImg,
    themeColor: "#071018",
    starsColor: "#E53935",
    themeClass: "potion-card--brucolaque",
    description:
      "Remplace un mot joué il y a 0 à 7 jours par un mot joué il y a plus de 7 jours.",
    gameTooltipDescription:
      "Remplace un mot joué il y a 0 à 7 jours par un mot joué il y a plus de 7 jours.",
    starsAnimationDelay: 0,
    cost: {
      specificGemId: "turquoise",
      specificGemCount: 1,
      commonGemCount: 2,
    },
  },
  {
    id: "baume-sursis",
    name: "Baume du Sursis",
    obtainArticle: "un",
    image: baumeSursisImg,
    themeColor: "#9B5BD6",
    starsColors: ["#E878B6", "#8B5CF6"],
    themeClass: "potion-card--sursis",
    description:
      "Reporte la question en fin de partie. À son retour, aucune potion n'est utilisable.",
    gameTooltipDescription:
      "Reporte cette question en fin de partie. Au retour, aucune potion utilisable.",
    starsAnimationDelay: 120,
    cost: {
      specificGemId: "aigue-marine",
      specificGemCount: 1,
      commonGemCount: 2,
    },
  },
  {
    id: METAMORPH_POTION_ID,
    name: "Liqueur du Métamorphe",
    obtainArticle: "une",
    image: liqueurMetamorpheImg,
    themeColor: "#D9772A",
    starsColors: ["#F5B041", "#E0552E"],
    themeClass: "potion-card--metamorphe",
    questPotion: true,
    description:
      "Remplace un objectif non entamé de la quête du jour par un type choisi (exigence au sort). Une fois par quête.",
    starsAnimationDelay: 360,
    cost: {
      specificGemId: "cornaline",
      specificGemCount: 5,
      commonGemCount: 10,
    },
  },
  {
    id: DEMI_LUNE_POTION_ID,
    name: "Philtre de la demi-lune",
    obtainArticle: "un",
    image: philtreDemiLuneImg,
    themeColor: "#5B4DC7",
    starsColors: ["#8B6CFF", "#3EC4F0"],
    themeClass: "potion-card--demi-lune",
    questPotion: true,
    catalogUsable: true,
    description:
      "Garanti 50% de chance de découvrir une relique sur la quête du lendemain.",
    starsAnimationDelay: 480,
    cost: {
      specificGemId: "diamant",
      specificGemCount: 5,
      commonGemCount: 20,
    },
  },
];

export const POTION_COLLECTION_PAGES = [
  ["decouverte", "bouillon-deja-vu", "mixture-3eme-oeil", "grog-veuve-noire"],
  ["serum-cadran", "remede-ignorance", "philtre-mnesique", "elixir-clarte"],
  ["mixture-du-brucolaque", "baume-sursis", "trefle-mineur", "trefle-majeur"],
  [METAMORPH_POTION_ID, DEMI_LUNE_POTION_ID],
];

/** Page du catalogue (bouton radio 3) où figurent les potions de trèfles. */
export const CLOVER_POTION_CATALOG_PAGE_INDEX = POTION_COLLECTION_PAGES.findIndex((page) =>
  page.includes("trefle-mineur")
);

/** Potions visibles dans la barre de jeu (ordre d'affichage). */
export const GAME_NAV_POTION_IDS = [
  "serum-cadran",
  "philtre-mnesique",
  "remede-ignorance",
  "elixir-clarte",
  "decouverte",
  "bouillon-deja-vu",
  "mixture-3eme-oeil",
  "grog-veuve-noire",
  "mixture-du-brucolaque",
  "baume-sursis",
];

/** Potions autorisées en mode T (test) — pas d'échange ni de trèfle. */
export const GAME_TEST_NAV_POTION_IDS = [
  "serum-cadran",
  "philtre-mnesique",
  "remede-ignorance",
  "elixir-clarte",
  "baume-sursis",
];

export function getGameNavPotionIdsForPlayMode(playMode) {
  return playMode === "test" ? GAME_TEST_NAV_POTION_IDS : GAME_NAV_POTION_IDS;
}

const potionsById = new Map(GAME_POTIONS.map((potion) => [potion.id, potion]));

export function getPotionsForCollectionPage(pageIndex) {
  const pageIds = POTION_COLLECTION_PAGES[pageIndex] || [];
  return pageIds.map((id) => potionsById.get(id)).filter(Boolean);
}

function formatGemName(gemId, count) {
  const label = humanizeGemLabel(`${gemId}.png`).toLocaleLowerCase("fr-FR");
  if (count <= 1) return `1 ${label}`;
  if (label === "rubis") return `${count} rubis`;
  if (label.endsWith("s")) return `${count} ${label}`;
  return `${count} ${label}s`;
}

const FEMININE_POTION_KINDS = new Set(["potion", "mixture", "liqueur"]);

export function formatPotionAbsenceLabel(potion) {
  const kind = String(potion?.name || "potion")
    .trim()
    .split(/\s+/)[0]
    .toLocaleLowerCase("fr-FR")
    .replace(/[().,]/g, "");
  const noun = kind || "potion";
  const article =
    noun === "élixir" || noun === "elixir"
      ? "cet"
      : FEMININE_POTION_KINDS.has(noun)
        ? "cette"
        : "ce";
  return `Vous ne possédez pas ${article} ${noun}`;
}

export function formatPotionObtainTitle(potion) {
  const article = potion.obtainArticle ?? "une";
  return `Obtenir ${article} ${potion.name}`;
}

export function formatPotionCost(potion) {
  const { specificGemId, specificGemCount, commonGemCount } = potion.cost;
  const specificPart = formatGemName(specificGemId, specificGemCount);
  const commonLabel =
    commonGemCount > 1 ? `${commonGemCount} pierres communes` : "1 pierre commune";
  return `${specificPart} ou ${commonLabel}`;
}

export function formatPotionCostLines(potion) {
  const { specificGemId, specificGemCount, commonGemCount } = potion.cost;
  const specificPart = formatGemName(specificGemId, specificGemCount);
  const commonLabel =
    commonGemCount > 1 ? `${commonGemCount} pierres communes` : "1 pierre commune";
  return {
    specificPart,
    commonPart: `ou ${commonLabel}`,
  };
}
